import {
  checkoutV202604,
  type operations,
} from "@fluid-app/checkout-api-client";
import { createPublicCheckoutApiClient } from "@/lib/checkout-api-client";

type QueryProductResponse =
  operations["checkout_v2026_04_query_product"]["responses"][200]["content"]["application/json"];

type QueryProductBody = NonNullable<
  operations["checkout_v2026_04_query_product"]["requestBody"]
>["content"]["application/json"];

type ProductResponse = Pick<QueryProductResponse, "variants">;

export async function getProduct(
  productId: number,
  fluidShop: string,
): Promise<ProductResponse> {
  const response = await checkoutV202604.checkout_v2026_04_query_product(
    createPublicCheckoutApiClient(),
    productId,
    {
      metadata: {
        fluid_shop: fluidShop,
      },
    } satisfies QueryProductBody,
  );

  return { variants: response.variants };
}
